const food_data =
  [
    {
      id: "2568016",
      imageId: "PC_Mweb/Pizza.png",
      action: {
        link: "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
        text: "Pizzas",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for pizza",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568339",
      imageId: "PC_Mweb/Biryani.png",
      action: {
        link: "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
        text: "Biryani",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for biryani",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568312",
      imageId: "PC_Mweb/Cake.png",
      action: {
        link: "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
        text: "Cakes",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for cake",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568574",
      imageId: "PC_Mweb/Burger.png",
      action: {
        link: "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
        text: "Burgers",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for burger",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568041",
      imageId: "PC_Mweb/Pasta.png",
      action: {
        link: "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
        text: "Pasta",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for pasta",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80479?collection_id=80479&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568346",
      imageId: "PC_Mweb/Noodles.png",
      action: {
        link: "https://www.swiggy.com/collections/80463?collection_id=80463&type=rcv2",
        text: "Noodles",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for noodles",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80463?collection_id=80463&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568034",
      imageId: "PC_Mweb/Rolls.png",
      action: {
        link: "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
        text: "Rolls",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for roll",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568353",
      imageId: "PC_Mweb/Momo.png",
      action: {
        link: "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
        text: "Momos",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for momos",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568341",
      imageId: "PC_Mweb/Pastry.png",
      action: {
        link: "https://www.swiggy.com/collections/80355?collection_id=80355&type=rcv2&tags=layout_ux4",
        text: "Pastry",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for Pastry",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80355?collection_id=80355&type=rcv2&tags=layout_ux4",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568015",
      imageId: "PC_Mweb/Chole%20Bhature.png",
      action: {
        link: "https://www.swiggy.com/collections/80382?collection_id=80382&tags=layout_CCS_CholeBhature&type=rcv2",
        text: "Chole Bhature",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for chhole bhatoore",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80382?collection_id=80382&tags=layout_CCS_CholeBhature&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568332",
      imageId: "PC_Mweb/Coffee.png",
      action: {
        link: "https://www.swiggy.com/collections/83659?collection_id=83659&tags=layout_CCS_Coffee&type=rcv2",
        text: "Coffee",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for coffee",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83659?collection_id=83659&tags=layout_CCS_Coffee&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568330",
      imageId: "PC_Mweb/Shawarma.png",
      action: {
        link: "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
        text: "Shawarma",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for shawarma",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568370",
      imageId: "PC_Mweb/Shake.png",
      action: {
        link: "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
        text: "Shake",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for shakes",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568019",
      imageId: "PC_Mweb/Tea.png",
      action: {
        link: "https://www.swiggy.com/collections/80406?collection_id=80406&tags=layout_CCS_Tea&type=rcv2",
        text: "Tea",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for tea",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80406?collection_id=80406&tags=layout_CCS_Tea&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568142",
      imageId: "PC_Mweb/Dosa.png",
      action: {
        link: "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
        text: "Dosa",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for dosa",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568324",
      imageId: "PC_Mweb/Khichdi.png",
      action: {
        link: "https://www.swiggy.com/collections/80455?collection_id=80455&type=rcv2",
        text: "Khichdi",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for khichdi",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80455?collection_id=80455&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568349",
      imageId: "PC_Mweb/Samosa.png",
      action: {
        link: "https://www.swiggy.com/collections/80396?collection_id=80396&type=rcv2",
        text: "Samosa",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for samosa",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80396?collection_id=80396&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568337",
      imageId: "PC_Mweb/Pav%20Bhaji.png",
      action: {
        link: "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
        text: "Pav Bhaji",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for pav bhaji",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568020",
      imageId: "PC_Mweb/Parotta.png",
      action: {
        link: "https://www.swiggy.com/collections/80477?collection_id=80477&type=rcv2",
        text: "Parotta",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for parotta",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80477?collection_id=80477&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    },
    {
      id: "2568338",
      imageId: "PC_Mweb/Patty.png",
      action: {
        link: "https://www.swiggy.com/collections/80360?collection_id=80360&type=rcv2",
        text: "Patty",
        type: "DEEPLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for patty",
        altTextCta: "open",
      },
      entityId:
        "https://www.swiggy.com/collections/80360?collection_id=80360&type=rcv2",
      frequencyCapping: {},
      externalMarketing: {},
      overlayIcon: {},
      footerOverlay: {
        title: {},
        subtitle: {},
        cta: {},
      },
    }
  ];

  export default food_data;